module.exports = __webpack_public_path__ + "img/s3.6b0cf178.png";